import WpIcon from"@wp/src/common/images/WpIcon";import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";import*as React from"react";import*as Humanize from"humanize-plus";export const ActionsIcon=styled(WpIcon)`
  cursor: pointer;
  &:before {
    width: 5px;
  }
`;export const ActionsContainer=styled(FlexLayout)`
  flex-wrap: nowrap;
`;export const InvestmentCountLabel=({investmentCount})=>{return React.createElement(React.Fragment,null,investmentCount," ",Humanize.pluralize(investmentCount,"security","securities")," and cash")};